import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react'
import React, { ReactNode } from 'react'

interface DialogComponentProps {
    title?: string
    open: boolean
    onClose: () => void
    children: ReactNode
    dialogClass?: string
}

const Modal: React.FC<DialogComponentProps> = ({ title, open, onClose, children, dialogClass }) => {
    return (
        <Transition show={open} as={React.Fragment}>
            <Dialog as="div" className="fixed inset-0 overflow-y-auto z-10" onClose={onClose}>
                <div className="flex items-center justify-center min-h-screen">
                    <TransitionChild
                        as={React.Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/30" />
                    </TransitionChild>

                    <TransitionChild
                        as={React.Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <div className="fixed inset-0 flex items-center justify-center p-4">
                            <DialogPanel className={`mx-auto w-full max-w-[600px] p-6 bg-white max-h-[98vh] overflow-y-auto ${dialogClass}`}>
                                <DialogTitle className="text-2xl font-bold flex justify-between leading-none max-tablet:text-xl">
                                    <div>{title}</div>
                                    <FontAwesomeIcon
                                        icon={['fas', 'xmark']}
                                        className="text-sm bg-blue-800 text-white px-1 py-1 cursor-pointer"
                                        onClick={onClose}
                                    />
                                </DialogTitle>

                                {children}
                            </DialogPanel>
                        </div>
                    </TransitionChild>
                </div>
            </Dialog>
        </Transition>
    )
}

export default Modal
